module.exports = "<p>\r\n  my-forecast works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/client/my-forecast/my-forecast.component.html
// module id = ./src/app/pages/client/my-forecast/my-forecast.component.html
// module chunks = main